import { intersection } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getCreativesWithCompatibleValues = data => {
  const countryCodeByProduct = {};
  const categoriesByProduct = {};
  const productTagsByProduct = {};
  if (data.campaignLinesById) {
    Object.values(data.campaignLinesById).forEach(campaignLine => {
      countryCodeByProduct[campaignLine.product.id] = [
        ...(countryCodeByProduct[campaignLine.product.id] || []),
        campaignLine.countryCode,
      ];
      categoriesByProduct[campaignLine.product.id] = [
        ...(categoriesByProduct[campaignLine.product.id] || []),
        ...campaignLine.categories,
      ];
      productTagsByProduct[campaignLine.product.id] = [
        ...(productTagsByProduct[campaignLine.product.id] || []),
        campaignLine.productTag,
      ];
    });
  }
  const creatives = Object.values(data.creativesById).map(creative => {
    const compatibleCategories = [];
    const compatibleCountries = [];
    const compatibleProductTags = [];
    if (creative.products && creative.products.compatibleProducts) {
      creative.products.compatibleProducts.forEach(({ id }) => {
        countryCodeByProduct?.[id]?.forEach(country =>
          compatibleCountries.push(country),
        );

        if (categoriesByProduct[id]) {
          categoriesByProduct[id].forEach(category => {
            if (!compatibleCategories.includes(category)) {
              compatibleCategories.push(category);
            }
          });
        }

        productTagsByProduct?.[id]?.forEach(tag => {
          if (tag && !compatibleProductTags.includes(tag)) {
            compatibleProductTags.push(tag);
          }
        });
      });
    }

    return {
      ...creative,
      countryCodes: compatibleCountries.length
        ? intersection(creative.countryCodes, compatibleCountries)
        : creative.countryCodes,
      productTags: compatibleProductTags.length
        ? intersection(creative.productTags, compatibleProductTags)
        : creative.productTags,
      categories: compatibleCategories.length
        ? intersection(creative.categories, compatibleCategories)
        : creative.categories,
      compatibleCountries,
      compatibleCategories,
      compatibleProductTags,
    };
  });
  return creatives;
};

export const getCompatibleUpdatedValues = (updatedValues, compatibleValues) => {
  if (compatibleValues && compatibleValues.length)
    return intersection(updatedValues, compatibleValues);
  return updatedValues;
};

export const getUpdatedValues = (creative, updatedValues) => {
  const { compatibleProductTags, compatibleCountries, compatibleCategories } =
    creative;
  const { countryCodes, productTags, categories } = updatedValues;
  return {
    countryCodes: countryCodes
      ? getCompatibleUpdatedValues(countryCodes, compatibleCountries)
      : creative.countryCodes,
    productTags: productTags
      ? getCompatibleUpdatedValues(productTags, compatibleProductTags)
      : creative.productTags,
    categories: categories
      ? getCompatibleUpdatedValues(categories, compatibleCategories)
      : creative.categories,
  };
};
